module.exports = "././img/footer.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/footer.png
// module id = 821
// module chunks = 0